import React, { Component } from 'react'
import { withRouter } from "react-router-dom";
import Http from '../../../../Http';
import { Button, InputLabel, FormControl, Select, MenuItem, TextField, Snackbar, Slide, IconButton, Icon } from '@material-ui/core';
import { Validators } from '../../../../components/form/DynamicFormTs';

class ClienteDatosContactos extends Component {

  state = {
    contactoTipos: [],
    contactos: [],
    sbOpen: false,
    sbMsg: '',
  }

  componentDidMount() {
    this.loadFormData();
  }

  loadFormData = async () => {
    let Res = await Http.get('cliente/form-contactos');
    console.log(Res.data)
    if (!Res.error) {
      this.setState({ contactoTipos: Res.data.contacto_tipos })
    }
    this.loadContactos();
  }

  loadContactos = async () => {
    let Res = await Http.get(`cliente/contactos?c=${this.props.match.params.id}`);
    if (!Res.error) {
      this.setState({ contactos: Res.data })
    }
  }

  agregarContacto = () => {
    let contactos = this.state.contactos;
    if (contactos.length >= 4) return;
    contactos.push({
      cco_id_cliente: this.props.match.params.id,
      cco_tipo: 1,
      cco_nombre: '',
      cco_email: '',
      cco_telefono: '',
      cco_extension: '',
      id: null
    })
    this.setState({ contactos })
  }

  conctactoChange = (i, prop, value) => {
    let contactos = this.state.contactos;
    contactos[i][prop] = value;
    this.setState({ contactos })
  }

  guardar = async () => {
    console.log(this.state.contactos)
    if (this.state.contactos.length < 1) return;
    let contactos = this.state.contactos;
    // VALIDAR CAMPOS
    for (var i in contactos) {
      if (contactos[i].cco_nombre.length < 2 || !Validators.email(contactos[i].cco_email)) {
        this.setState({ sbMsg: `Datos no válidos en contacto #${parseInt(i) + 1}`, sbOpen: true })
        return;
      }
      // console.log(contactos[i])
    }
    let Res = await Http.post('cliente/contactos/save', { contactos });
    console.log(Res)
    if (!Res.error) {
      this.setState({ contactos: Res.data, sbMsg: 'Contactos guardados', sbOpen: true })
    }

  }

  contactoDelete = async (idx) => {
    let Res = await Http.post('cliente/contacto/delete', { id: this.state.contactos[idx].id });
    if (!Res.error) {
      this.setState({ sbMsg: `Contacto ${this.state.contactos[idx].cco_nombre} eliminado`, sbOpen: true })
      // this.setState({ contactos: Res.data })
      this.loadContactos();
    }
  }

  render() {
    const { contactoTipos, contactos, sbOpen, sbMsg } = this.state;
    return (
      <div>
        <div className='form-box'>
          <h4>Datos de contactos</h4>
          <div style={{ textAlign: 'right', paddingTop: 10, paddingBottom: 10 }}>
            <Button variant="contained" color="primary" onClick={this.agregarContacto}>Agregar contacto</Button>
          </div>
          <div className='preguia-detalles-paquetes'>
            <div hidden={contactos.length > 0} style={{ textAlign: 'center' }}>SIN CONTACTOS</div>
            {contactos.map((conctacto, i) => (
              <div className='row' key={i}>
                <div className='col-12 col-sm-2'>
                  <FormControl variant="outlined" className='form-field'>
                    <InputLabel>Tipo</InputLabel>
                    <Select
                      value={conctacto.cco_tipo}
                      onChange={(e) => { this.conctactoChange(i, 'cco_tipo', e.target.value) }}
                    >
                      {contactoTipos.map((ctipo, i) => (
                        <MenuItem value={ctipo.id} key={i}>{ctipo.cliente_contacto_tipo}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div className='col-12 col-sm-3'>
                  <TextField className='form-field' type='text' label="Nombre" value={conctacto.cco_nombre} variant="outlined" onChange={(e) => { this.conctactoChange(i, 'cco_nombre', e.target.value) }} />
                </div>
                <div className='col-12 col-sm-3'>
                  <TextField className='form-field' type='email' label="Correo" value={conctacto.cco_email} variant="outlined" onChange={(e) => { this.conctactoChange(i, 'cco_email', e.target.value) }} />
                </div>
                <div className='col-12 col-sm-2'>
                  <TextField className='form-field' type='text' label="Teléfono" value={conctacto.cco_telefono} variant="outlined" onChange={(e) => { this.conctactoChange(i, 'cco_telefono', e.target.value) }} />
                </div>
                <div className='col-12 col-sm-1'>
                  <TextField className='form-field' type='number' label="Ext" value={conctacto.cco_extension} variant="outlined" onChange={(e) => { this.conctactoChange(i, 'cco_extension', e.target.value) }} />
                </div>
                <div className='col-12 col-sm-1 preguia-detalles-delete'>
                  <IconButton onClick={() => { this.contactoDelete(i) }}>
                    <Icon>remove_circle</Icon>
                  </IconButton>
                </div>
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'right', paddingTop: 10, paddingBottom: 10 }}>
            <Button variant="contained" color="primary" onClick={this.guardar}>Guardar contactos</Button>
          </div>

          <Snackbar
            open={sbOpen}
            onClose={() => { this.setState({ sbOpen: false }) }}
            TransitionComponent={Slide}
            message={<span>{sbMsg}</span>}
          />
        </div>
      </div>
    )
  }
}

export default withRouter(ClienteDatosContactos)
